import React from 'react';

export const LocalDeliveryTime = (start: string, end: string) => {
    return (
        <span>
            <b>{(new Date(start)).toLocaleDateString([], { weekday: 'long' })}</b>&nbsp;({(new Date(start)).toLocaleDateString()})
        <br />
            {new Date(start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            &nbsp;-&nbsp;{new Date(end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </span>
    )
}